<template>
  <div>
    <vue-content-loading :width="300" :height="300" class="s">
      <rect x="0" y="0" rx="4" ry="4" width="400" height="100"/>
      <rect x="0" y="110" rx="4" ry="4" width="200" height="15"/>
      <rect x="220" y="110" rx="4" ry="4" width="60" height="15"/>

      <rect x="0" y="150" rx="4" ry="4" width="300" height="15"/>
      <rect x="0" y="175" rx="4" ry="4" width="270" height="15"/>
      <rect x="0" y="200" rx="4" ry="4" width="290" height="15"/>
      <rect x="0" y="225" rx="4" ry="4" width="300" height="15"/>
      <rect x="0" y="270" rx="4" ry="4" width="100" height="20"/>
    </vue-content-loading>
  </div>
</template>
<script type="text/javascript">
  import VueContentLoading from 'vue-content-loading';
  export default {
    name:'Tour Loading',
    components: {
      VueContentLoading
    }
  }
</script>
